import { FaExclamationTriangle } from "react-icons/fa";

const LiveRankings = () => {
  return (
    // <div className="col-12 col-md-4 mb-4">
      <div className="rounded border shadow-sm bg-dark text-light border-primary">
        <div className="p-4">
          <h5 className="text-light fw-bold mb-3">Live Rankings</h5>
          <div className="text-center">
            <FaExclamationTriangle size={32} className="text-warning mb-2" />
            <p className="text-muted">Rankings will appear once the contest begins</p>
            <small className="text-muted">Top performers updated in real-time</small>
          </div>
        </div>
      </div>
    // </div>
  );
};

export default LiveRankings;